<template>
  <main class="home-page">
    <HeroSection />
  </main>
</template>

<script setup>
  import HeroSection from '@/components/HeroSection.vue';
  import BrandsLogoBand from '@/components/BrandsLogoBand.vue';
  import RecordingStepsSection from '@/components/RecordingStepsSection.vue';
  import WhyChooseUsSection from '@/components/WhyChooseUsSection.vue';
  import SectionCtaCard from '@/components/SectionCtaCard.vue';
  import StackSectionDivider from '@/components/StackSectionDivider';
  import RecordGuideSection from '@/components/RecordGuideSection';
  import EditVideoCTASection from '@/components/EditVideoCTASection';
  import UsingScreenCaptureSection from '@/components/UsingScreenCaptureSection';
  import FeaturedUsersSection from '@/components/FeaturedUsersSection';
  import ProRecordingTipsSection from '@/components/ProRecordingTipsSection';
  import FAQSection from '@/components/FAQSection';
  import StartCreatingCTASection from '@/components/StartCreatingCTASection';
  import FooterSection from '@/components/FooterSection';
</script>

<style lang="scss">
  .home-page {
    @media only screen and (min-width: 0) {
      padding-top: 60px;
      .brands-logo-band {
        margin-top: 48px;
      }
    }
  }
</style>
